import { createContext } from 'react';

const MockupStoreContext = createContext<'preview' | 'product'>('preview');

export default MockupStoreContext;
